'use strict';
import { Infoblock } from './infoblock.js';

export class InfoblockLocation extends Infoblock {
	
	constructor(component_id) {
		super(component_id);
		
		this.data = yalwa.v.components[this.id].data;
		
		this.vue_data_vars = {
			locations: structuredClone(this.data.locations || []),       // working copy
			locationsFromBE: structuredClone(this.data.locations || []), // original
			
			isWholeCountry: false,
			
			locationOne: '',
			locationTwo: '',
			locationThree: ''
		};
		
		this.vue_method_vars = {
			
			// ------------------------
			// SAVE
			// ------------------------
			saveIconBoxData() {
				this.is_saving = true;
				
				const payload = this.locations.map(loc => {
					
					if (loc._deleted && loc.areaID) {
						return {
							areaID: loc.areaID,
							deleted: true
						};
					}
					
					if (loc.areaID) {
						return {
							areaID: loc.areaID
						};
					}
					
					return null;
					
				}).filter(Boolean);
				
				yalwa.basics.ajaxservice({
					type: 'POST',
					resource: 'profileupdate',
					action: 'update_locations',
					data: {
						data: JSON.stringify(payload),
						is_whole_country: this.isWholeCountry
					},
					include_session: true,
					is_cross_origin: false
				}).then(response => {
					
					if (response.type === 'success') {
						if (response.vip_completion) {
							document.dispatchEvent(new CustomEvent('vip_guide_state', {detail: response.vip_completion}));
						}
						this.locations = structuredClone(response.locations);
						this.locationsFromBE = structuredClone(response.locations);
						this.reset();
						this.close();
					}
					
					yalwa.basics.toast({
						message: response.label,
						type: response.type
					});
				}).finally(() => {
					this.is_saving = false;
				});
				this.reset();
				this.initCityAutocomplete();
			},
			
			// ------------------------
			// WHOLE COUNTRY
			// ------------------------
			selectEntireCountry(e) {
				this.isWholeCountry = e.target.checked;
				this.reset();
			},
			
			// ------------------------
			// RESET INPUTS
			// ------------------------
			reset() {
				this.locationOne = '';
				this.locationTwo = '';
				this.locationThree = '';
			},
			
			// ------------------------
			// INIT
			// ------------------------
			initialize() {
				this.isWholeCountry = this.checkIfEntierCountry();
				this.formatDataForUI();
				this.initCityAutocomplete();
			},
			
			checkIfEntierCountry() {
				return this.locations && parseInt(this.locations[0]?.areaID) === 0;
			},
			
			formatDataForUI() {
				if (this.locations && this.locations[0]?.areaID > 0) {
					this.locationOne = this.locations[0]?.text || '';
					this.locationTwo = this.locations[1]?.text || '';
					this.locationThree = this.locations[2]?.text || '';
				}
			},
			
			// ------------------------
			// AUTOCOMPLETE
			// ------------------------
			initCityAutocomplete() {
				this.$nextTick(() => {
					this.initAutoComplete('js-vip_profile_location', 1);
					this.initAutoComplete('js-vip_profile_location', 2);
					this.initAutoComplete('js-vip_profile_location', 3);
				});
			},
			
			initAutoComplete(className, key) {
				
				const selector = `.${className}_${key}`;
				const $el = jQuery(selector);
				
				if (!$el.length) return;
				
				if ($el.data('autocomplete')) {
					$el.autocomplete('dispose');
				}
				
				$el.autocomplete({
					serviceUrl: '/api/geo/geo_search_autocomplete',
					minChars: 2,
					zIndex: 9999,
					paramName: 'term',
					appendTo: $el.parent(),
					deferRequestBy: 200,
					orientation: 'auto',
					params: {
						routing: yalwa.basics.get_routing()
					},
					
					onSelect: (suggestion) => {
						
						const newLoc = {
							areaID: suggestion.data?.areaID || suggestion?.areaID,
							text: suggestion.value,
							areaURL: suggestion.data?.url || '#',
							_deleted: false
						};
						
						const updated = [...this.locations];
						
						updated[key - 1] = newLoc;
						
						this.locations = updated;
						
						switch (key) {
							case 1: this.locationOne = suggestion.value; break;
							case 2: this.locationTwo = suggestion.value; break;
							case 3: this.locationThree = suggestion.value; break;
						}
					}
				});
			},
			
			// ------------------------
			// DELETE (LOCAL ONLY)
			// ------------------------
			deleteRecord(areaID, index) {
				
				const updated = [...this.locations];
				
				if (updated[index]?.areaID) {
					updated[index] = {
						...updated[index],
						_deleted: true
					};
				} else {
					updated[index] = {};
				}
				
				this.locations = updated;
				this.reset();
				this.initCityAutocomplete();
			},
			
			// ------------------------
			// CLOSE / RESET
			// ------------------------
			close() {
				this.locations = JSON.parse(JSON.stringify(this.locationsFromBE));
				this.reset();
				this.closeDialog();
				this.initCityAutocomplete();
			}
		};
		
		this.extras = {
			computed: {
				
				// ------------------------
				// CHANGE DETECTION
				// ------------------------
				isUnchanged() {
					
					const normalize = (arr) => (arr || [])
						.map(l => ({
							id: l.areaID || 0,
							deleted: l._deleted || false
						}));
					
					return JSON.stringify(normalize(this.locations)) ===
						JSON.stringify(normalize(this.locationsFromBE))
						&& this.isWholeCountry === (this.locationsFromBE[0]?.areaID === 0);
				}
			},
			
			mounted() {
				this.initialize();
			}
		};
	}
	
	// IMPORTANT: keep empty
	setup_vars(Vue) {
		this.locations = Vue.ref();
	}
}